/*
|--------------------------------------------------------------------------
| easel-event-binder.js
|--------------------------------------------------------------------------
|
| Binds all requested EaselJS events to a Vue component
|
*/

// Need to add and test these events for Canvas
// * drawend
// * drawstart
// * mouseenter
// * mouseleave
// * stagemousedown
// * stagemousemove
// * stagemouseup
// * tickend
// * tickstart

import intersection from 'lodash.intersection';

export var eventTypes = [
    'added',
    'animationend',
    'change',
    'click',
    'dblclick',
    'mousedown',
    'mouseout',
    'mouseover',
    'pressmove',
    'pressup',
    'removed',
    'rollout',
    'rollover',
    'tick',
];

export default {
    bindEvents: function bindEvents(component, object) {
        var listenerNames = Object.keys(component.$options._parentListeners || {});
        var requestedEvents = intersection(eventTypes, listenerNames);
        requestedEvents.forEach(function (eventType) {
            object.addEventListener(eventType, function (event) { return component.$emit(eventType, event); });
        });
    }
};



// WEBPACK FOOTER //
// ./src/libs/easel-event-binder.js